export default class Model {
  constructor() {
    if (!this.id) {
      this.id = {
        fieldName: 'id',
        content: null
      };
    }
  }
  getId() {
    var _this$Id$content, _this$Id, _this$id;
    return (_this$Id$content = (_this$Id = this.Id) === null || _this$Id === void 0 ? void 0 : _this$Id.content) !== null && _this$Id$content !== void 0 ? _this$Id$content : (_this$id = this.id) === null || _this$id === void 0 ? void 0 : _this$id.content;
  }
}